var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDealBreakerSelect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "20px",
    viewBox: "0 0 90 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDealBreakerSelect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deal-breakers-selected",
    transform: "translate(-268.000000, -429.000000)",
    fill: "#FF0000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDealBreakerSelect",
    transform: "translate(268.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.1,
    x: 0,
    y: 0,
    width: 90,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Deal-breaker",
    fontFamily: "Muli-Regular, Muli",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9,
    y: 14
  }, "Deal breaker"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDealBreakerSelect);
export default __webpack_public_path__ + "static/media/icDealBreakerSelect.61a4779e54d11764ff081431938c41c6.svg";
export { ForwardRef as ReactComponent };